export const SUPPORTED_LANGUAGES = ["en", "es", "pt", "fr", "ja", "de"] as const;
export const DEFAULT_LANGUAGE = "en";
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

/** First URL segment when it is a supported locale, otherwise the default. */
export function resolveLangFromPathname(pathname: string): SupportedLanguage {
  const segment = pathname.split("/")[1];
  return (SUPPORTED_LANGUAGES as readonly string[]).includes(segment)
    ? (segment as SupportedLanguage)
    : DEFAULT_LANGUAGE;
}
